interface Slot {
  time: string;
  candidate: string;
  alreadyBooked: boolean;
  takeAction: boolean;
  hasExternalCalendarEvent: boolean;
  externalCalendarEventTitle: string;
}

const getMeetingSlots = (workingHours: string): Slot[] => {
  const startHour = workingHours.split('-')[0];
  const endHour = workingHours.split('-')[1];

  return availableStartTimes
    .map((time, idx) => {
      const inWorkingHoursRange =
        idx >= availableStartTimes.indexOf(startHour) &&
        idx <= availableStartTimes.indexOf(endHour);

      if (inWorkingHoursRange) return generateSlot(time);
    })
    .filter((slot) => slot);
};

const generateSlot = (time: string) => {
  return {
    time,
    candidate: '',
    alreadyBooked: false,
    takeAction: false,
    hasExternalCalendarEvent: false,
    externalCalendarEventTitle: '',
  };
};

export const availableStartTimes = [
  '00:00',
  '00:30',
  '01:00',
  '01:30',
  '02:00',
  '02:30',
  '03:00',
  '03:30',
  '04:00',
  '04:30',
  '05:00',
  '05:30',
  '06:00',
  '06:30',
  '07:00',
  '07:30',
  '08:00',
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00',
  '16:30',
  '17:00',
  '17:30',
  '18:00',
  '18:30',
  '19:00',
  '19:30',
  '20:00',
  '20:30',
  '21:00',
  '21:30',
  '22:00',
  '22:30',
  '23:00',
  '23:30',
];

const getAllAvailableStartTimes = () => {
  const x = 1; //minutes interval
  const times = []; // time array
  let tt = 0; // start time
  const ap = ['']; // AM-PM (currently none)

  for (let i = 0; tt < 24 * 60; i++) {
    const hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
    const mm = tt % 60; // getting minutes of the hour in 0-59 format
    times[i] = ('0' + (hh % 24)).slice(-2) + ':' + ('0' + mm).slice(-2) + ap[Math.floor(hh / 24)];
    tt = tt + x;
  }

  return times;
};

// array of every minute in the day
export const allAvailableStartTimes = getAllAvailableStartTimes();

export default getMeetingSlots;
